export const PRESENTATION_ROLES = [
  "global_navigation",
  "shared_party_selection",
  "mission_board",
  "mission_detail",
  "mission_active",
  "mission_result",
  "black_keep_floor",
  "black_keep_combat",
  "black_keep_first_clear",
  "black_keep_repeat_result",
  "expedition_detail",
  "expedition_map_overlay",
  "expedition_encounter",
  "expedition_choice",
  "expedition_combat",
  "expedition_boss",
  "expedition_retreat",
  "expedition_completion",
  "world_hunt_detail",
  "world_hunt_combat",
  "world_hunt_result",
  "kingdom_threat_detail",
  "kingdom_threat_attack",
  "kingdom_threat_milestone",
  "kingdom_threat_completion",
  "pvp_map_overlay",
  "pvp_scout",
  "pvp_raid_setup",
  "pvp_battle_result",
  "pvp_battle_log",
  "pvp_denounce",
  "pvp_envoy",
  "pvp_proclamation",
  "dialogue_scene",
  "dialogue_box",
] as const;

export type PresentationRole = typeof PRESENTATION_ROLES[number];
export type PresentationSystem = "global" | "mission" | "black_keep" | "expedition" | "world_hunt" | "kingdom_threat" | "pvp" | "dialogue";

export type PresentationTemplateBinding = {
  id: string;
  documentId: string;
  system: PresentationSystem;
  role: PresentationRole | "legacy_review";
  isDefault: boolean;
  ownerId?: string;
  status: "active" | "needs_review";
};

export type TemplateRenderContext = {
  role: PresentationRole;
  title?: string;
  body?: string;
  artworkAssetId?: string;
  characterIds?: string[];
  choiceLabels?: string[];
  rewardIds?: string[];
  enemyId?: string;
  progress?: { current: number; maximum: number; label: string };
  values?: Record<string, string | number | boolean | null>;
};

export type EditorPreviewScenario = {
  id: string;
  label: string;
  role: PresentationRole;
  context: TemplateRenderContext;
};

export function presentationSystemForRole(role: PresentationRole): PresentationSystem {
  if (role.startsWith("mission_")) return "mission";
  if (role.startsWith("black_keep_")) return "black_keep";
  if (role.startsWith("expedition_")) return "expedition";
  if (role.startsWith("world_hunt_")) return "world_hunt";
  if (role.startsWith("kingdom_threat_")) return "kingdom_threat";
  if (role.startsWith("pvp_")) return "pvp";
  if (role.startsWith("dialogue_")) return "dialogue";
  return "global";
}

export const PRESENTATION_ROLE_LABELS: Record<PresentationRole, string> = Object.fromEntries(
  PRESENTATION_ROLES.map((role) => [role, role.split("_").map((word) => word[0]!.toUpperCase() + word.slice(1)).join(" ")]),
) as Record<PresentationRole, string>;
